import { money } from './format';

export function formatProfitUsd(cents: number): string {
	return money.format(cents / 100);
}
